import React, { FC } from 'react'
import classNames from 'classnames'
import LaneArrowIcon from 'transfix-icons/build/LaneArrowIcon'
import { Typography, Box } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useStopSummaryItem } from 'apps/fleet-planner/components/load-details/stops/StopsSummaryStyles'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'
import { formatCityState } from 'utils/formatCityState'

interface ILaneSummaryProps {
  className?: string
  dedicatedLane?: DedicatedLanesResponse
}

export const LaneSummary: FC<ILaneSummaryProps> = ({ className, dedicatedLane = {} }) => {
  const { isMobile } = useBreakpointContext()
  const { delivery, id, pickup } = dedicatedLane || {}
  const { city: pickupCity, stateCode: pickupStateCode } = pickup || {}
  const { city: deliveryCity, stateCode: deliveryStateCode } = delivery || {}
  const styles = useStopSummaryItem()
  const classes = classNames('mt1', styles.root, className)

  return (
    <Box paddingTop={2} paddingBottom={isMobile ? 2 : 0}>
      <Typography variant='overline' color='textSecondary' data-test='lane-summary-award-id'>
        AWARD ID #{id ?? ''}
      </Typography>
      <div className={classes}>
        <Typography variant='h3' data-test='lane-summary-pickup-city'>
          {formatCityState(pickupCity || '', pickupStateCode || '')}
        </Typography>
        <div className={isMobile ? 'ma1' : styles.root}>
          <LaneArrowIcon size='xlarge' color='coolGray5' />
        </div>
        <Typography variant='h3' data-test='lane-summary-delivery-city'>
          {formatCityState(deliveryCity || '', deliveryStateCode || '')}
        </Typography>
      </div>
    </Box>
  )
}
